<template>
    <small-dialog
        @ok="enroll"
        v-model="dialog"
        title="Daftarkan pengguna"
        okButton="daftarkan"
        :okDisabled="! selectedPeriodId"
        loading="createEnrollment"
    >
        <template #activator="{ on }">
            <v-btn @click="fetchPeriods" v-on="on" color="primary" small>
                <v-icon left>mdi-plus</v-icon>
                daftarkan
            </v-btn>
        </template>

        <v-autocomplete
            v-model="selectedPeriodId"
            :items="periods"
            label="Periode"
            :loading="isPeriodLoading"
            autofocus
        ></v-autocomplete>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

export default {
    props: {
        existingEnrollments: {
            type: Array,
            required: true
        },

        user: {
            type: Object,
            required: true,
        }
    },

    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        periods: [],
        isPeriodLoading: true,
        selectedPeriodId: null,
    }),

    methods: {
        async fetchPeriods() {
            this.isPeriodLoading = true

            const response = await this.$api.get('period')
            const existingPeriodIds = this.existingEnrollments
                .map(enrollment => enrollment.period.id)

            this.periods = response.data.periods
                .filter(period => ! existingPeriodIds.includes(period.id))
                .map(period => ({
                    text: period.title,
                    value: period.id
                }))

            this.periods.reverse()

            this.isPeriodLoading = false
        },

        async enroll() {
            await this.$apiv2.post(`user/${this.user.id}/enrollment`, {
                periodId: this.selectedPeriodId
            }, { loader: 'createEnrollment' })

            this.$emit('enroll')
            this.dialog = false
        }
    },
}
</script>
